









import Vue, { PropType } from 'vue'
import { Actions } from '@/shared/Actions'

export default Vue.extend({
  name: 'Spinner',
  props: {
    action: {
      type: String as PropType<Actions>,
      default: undefined
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 1.7
    }
  },
  computed: {
    isProcessing(): boolean {
      return this.isLoading || this.$store.state.isProcessing[this.action]
    },
    spinnerStyle(): any {
      return {
        width: `${this.size}em`,
        height: `${this.size}em`,
        'border-width': `${(this.size as number) / 4}em`
      }
    }
  }
})
